import { RestaurantAnimationDto } from '@timechef/core/api';

export interface AnimationsByPeriod {
  period: AnimationsPeriodEnum;
  items: RestaurantAnimationDto[];
}

export enum AnimationsPeriodEnum {
  Today = 'Today',
  Incoming = 'Incoming',
}

export interface PageInfo {
  hasMore: boolean;
  currentPageIndex: number;
}

export interface PageInfoWithData<T> extends PageInfo {
  data: T[];
}
